import React, { useState } from "react";
import DataCollectionEdit from "./data-collection-edit";
import { useSearchParams } from "react-router-dom";

const DataCollection = ({ data }) => {
  const record = data;
  const [searchParams, setSearchParams] = useSearchParams();

  const handleNextPage = () => {
    setSearchParams({ tab: "data-flow" });
  };
  const handleBack = () => {
    setSearchParams({ tab: "about" });
  };
  const [isEditing, setIsEditing] = useState(false);
  if (isEditing) {
    return <DataCollectionEdit data={data} setIsEditing={setIsEditing} />;
  }
  return (
    <div className="font-Inter">
      {/* Card Header */}
      <div className="flex items-center gap-5 font-Inter">
        <h2 className=" font-semibold text-[#101828]">Data Collection</h2>
        <button
          onClick={() => setIsEditing(true)}
          className="text-[#2070B8] text-sm font-medium"
        >
          Edit Details
        </button>
      </div>

      {/* Card Content */}
      <div className="py-4 space-y-4">
        <div className="space-y-2">
          <label className="block text-sm font-medium text-[#3B3B3B]">
            Name of the tool used to collect data *
          </label>
          <p className="text-[#667085] text-sm font-medium">
            {data?.toolUsedToCollectData}
          </p>
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-[#3B3B3B]">
            What technology is used to collect the information *
          </label>
          <p className="text-[#667085] font-medium text-sm">
            {record.informationCollectionTool}
          </p>
        </div>

        {/* <div className="space-y-2">
          <label className="block text-sm font-medium text-[#3B3B3B] ">
            Date of first installation <span className="text-[#3B3B3B]">*</span>
          </label>
          <p className="text-[#667085] text-sm font-medium">
            {record?.dateInstalled}
          </p>
        </div> */}

        <div className="space-y-2">
          <label className="block text-sm font-medium text-[#3B3B3B]">
            How often is data collected *
            <span className="text-[#3B3B3B]">*</span>
          </label>
          <p className="text-[#667085] text-sm font-medium">
            {/* {record?.annualLicenseFeeCurrency || ""}{" "}
            {numberWithCommas(record?.annualLicenseFee || "")} */}
            {record.oftenCollected}
          </p>
        </div>

        <div className="space-y-2">
          <label className="block text-sm font-medium text-[#3B3B3B] ">
            How well does the data collection tool serve its purpose?
            <span className="text-[#3B3B3B]">*</span>
          </label>
          <p className="text-[#667085] leading-relaxed text-sm font-medium">
            {record?.dataCollectionToolPurposeServe}
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex gap-3 pt-6">
          <button
            onClick={handleBack}
            className="px-12 py-2.5 border border-[#D0D5DD] text-[#344054] font-medium rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
          >
            Go Back
          </button>
          <button
            onClick={handleNextPage}
            className="px-12 py-2.5 bg-[#2070B8] font-medium text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-colors"
          >
            Next Page
          </button>
        </div>
      </div>
    </div>
  );
};

export default DataCollection;
